var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.999 14.8135C11.3737 14.8135 10.8551 14.3601 10.8551 13.8135V13.5335C10.8551 11.9869 12.1515 11.2268 12.6396 10.9335C13.2039 10.6002 13.3869 10.3735 13.3869 10.0269C13.3869 9.36019 12.7616 8.81348 11.999 8.81348C11.2364 8.81348 10.6111 9.36019 10.6111 10.0269C10.6111 10.5735 10.0925 11.0269 9.46716 11.0269C8.84182 11.0269 8.32324 10.5735 8.32324 10.0269C8.32324 8.25352 9.97045 6.81348 11.999 6.81348C14.0275 6.81348 15.6748 8.25352 15.6748 10.0269C15.6748 11.5469 14.3936 12.3068 13.9208 12.5868C13.326 12.9335 13.1429 13.1602 13.1429 13.5335V13.8135C13.1429 14.3735 12.6243 14.8135 11.999 14.8135Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 18.1338C11.1156 18.1338 10.4209 17.6805 10.4209 17.1338C10.4209 16.5871 11.1367 16.1338 11.9998 16.1338C12.863 16.1338 13.5788 16.5871 13.5788 17.1338C13.5788 17.6805 12.8841 18.1338 11.9998 18.1338Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/HelpIcon.fa78f0597386ac38402875640590a8e0.svg";
export { ForwardRef as ReactComponent };